<ng-container *ngIf="content">
    <h4 *iCms="'title' of content"
        class="h2"></h4>
    <p *iCms="'subtitle' of content"
       [class.col-2]="displayWarning"
       class="p1 m-t-2"></p>

    <button class="pos-absolute z-2 top-0 right-0 p-a"
            role="button"
            aria-label="Close"
            (click)="close()">
        <i class="icon-close"
           aria-hidden="true"></i>
    </button>


    <div class="m-t m-t-5-s m-t-5-m w-12 no-wrap _giftsContainer"
         dragScroll>

        <ng-container *ngFor="let item of giftProducts; let isLast = last">
            <div *ngIf="item.parent && item.simpleProducts?.length"
                 class="_product p-a left inline-block _gift cursor-pointer"
                 [style.width.px]="client.sizeId > 1 ? (giftProducts?.length || 0) > 3 ? 250 : 296 : 226"
                 [class.m-r]="!isLast"
                 [ngClass]="selectedParent === item.parent.id ? '_selected' : 'bg-col-5'"
                 (click)="selectParent(item.parent.id)">
                <div class="ratio-3-4 w-12">
                    <img class="rf"
                         draggable="false"
                         [image]="item.parent.data?.image">
                </div>
                <p class="line-clamp-2 m-t-2 _productName"
                   [sizeClass]="'SM:p2, XL: p1'">{{item.parent.name}}</p>

                <input-wrap *ngIf="item.simpleProducts.length"
                            class="w-12 m-t-5"
                            [messages]="{required: 'Select Size' | translate}">
                    <select class="select"
                            name="size"
                            [muiInput]
                            [(ngModel)]="item.selectedProductId"
                            (ngModelChange)="detectChanges()"
                            [style.padding-top]="0">
                        <option [value]="undefined">{{'Select Size' | translate}}</option>
                        <ng-container *ngFor="let product of item.simpleProducts">
                            <option [value]="product.id"
                                    *ngIf="product?.data?.size">
                                {{product.data.size! | optionLabel : 'size'}}
                            </option>
                        </ng-container>
                    </select>
                </input-wrap>
            </div>
        </ng-container>
    </div>

    <action class="button m-t m-t-5 m-t-5"
            [status]="confirmStatus"
            (click)="confirm()">{{!canConfirm ?
        content.selectSizeButtonCopy || ('Select an option' | translate)
        : content.addButtonCopy || ('Add free gift' | translate)}}</action>
</ng-container>
